import {FieldNames} from '../../../../fields'
import {ChangeableFieldsOptionsDtoPaths} from '../../options/types'

export const OPTION_PATH_TO_FIELDNAME_MAPPING: {
  optionsPath: ChangeableFieldsOptionsDtoPaths
  fieldName: FieldNames
}[] = [
  {optionsPath: 'quantity', fieldName: {field: 'quantity.volume'}},
  {optionsPath: 'quantity', fieldName: {field: 'quantity.quantityUom'}},
  {optionsPath: 'quantity', fieldName: {field: 'quantity'}},
  {optionsPath: 'maxLoadSize', fieldName: 'maxLoadSize'},
  {optionsPath: 'quantityChangeExpected', fieldName: {field: 'plusLoadExpected'}},
  {optionsPath: 'isConfirmedByCustomer', fieldName: {field: 'isConfirmedOrder'}},
  {optionsPath: 'customerReference', fieldName: {field: 'poNumber'}},
  {optionsPath: 'loadSpace', fieldName: {field: 'spacingOrFlowRate'}},
  {optionsPath: 'flowRate', fieldName: {field: 'spacingOrFlowRate'}},
  {optionsPath: 'timeOnJobSite', fieldName: {field: 'timeOnJobSite'}},
  {optionsPath: 'orderChangeNotes', fieldName: {field: 'additionalNotes'}},
  {optionsPath: 'siteContact', fieldName: {field: 'siteContact'}},
  {optionsPath: 'isTestBooked', fieldName: {field: 'isTestBooked'}},
  {optionsPath: 'contractNumber', fieldName: {field: 'contract'}},
  {optionsPath: 'contractItem', fieldName: {field: 'contract'}},
  {optionsPath: 'materialNumber', fieldName: {field: 'material'}},
  {optionsPath: 'slump', fieldName: {field: 'materialVariations'}},
  {optionsPath: 'setControl', fieldName: {field: 'materialVariations'}},
  {optionsPath: 'shippingDate.date', fieldName: {field: 'dateTime', fieldPart: 'date'}},
  {optionsPath: 'shippingDate.date', fieldName: 'dateTime'},
  {optionsPath: 'shippingDate.time', fieldName: {field: 'dateTime', fieldPart: 'time'}},
  {optionsPath: 'shippingDate.time', fieldName: 'dateTime'}
]
